<template>
  <div :class="['station-btngroup-button', active ? 'active' : '']" @click.prevent="$emit('click', $event)">
    <slot />
    <span :class="['badge', badgeClass]" v-if="badge > 0">{{badge}}</span>
  </div>
</template>

<script>
export default {
  name: 'StationButtonGroupButton',
  props: {
    active: Boolean,
    badge: {
      type: Number,
      default: 0
    },
    badgeClass: {
      type: String,
      default: 'badge-danger'
    },
  }
}
</script>